// extracted by mini-css-extract-plugin
module.exports = {"centered":"_1C3zIa2G","ownerColumn":"rBByRPxZ","icon":"_3ry2-6j2","widgetsTooltip":"_1ywMN3Jy","widgetsTooltipWrapper":"SRnDW-xT","labelDecoy":"_1kF2x9h4"};